<template>
  <div class="c-folder-layer__item d-flex align-items-center mt-2">
    <div class="c-folder-layer__item--preview mr-2">
      <img
        v-if="src"
        class="layer--item__img"
        :src="src"
        :alt="name"
      >
      <b-icon
        v-else
        :icon="fallbackIcon.icon"
        class="d-block"
        :style="{ color: fallbackIcon.color }"
      />
    </div>
    <div
      ref="tooltip"
      class="layer--item__text"
    >
      <b-tooltip
        :show.sync="isTooltipShown"
        :target="() => $refs.tooltip"
        triggers="hover"
        boundary="viewport"
        noninteractive
        :disabled="isNotTruncated(name)"
      >
        {{ name }}
      </b-tooltip>
      <EditableTextElement
        :default-value="name"
        :disabled="isSavingNodesChanges"
        :render-value="truncateFieldName"
        @change="changeLayerName"
      />
    </div>
  </div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";
import EditableTextElement from "@frontend/components/common/atoms/EditableTextElement.vue";
import layerMixin from './mixin';
import {PARSED_FIELD_TYPES} from "@/includes/parse_psd_data/constants";

const { mapGetters } = createNamespacedHelpers('psdLayers');

const FALLBACK_ICONS = {
  [PARSED_FIELD_TYPES.RECTANGLE]: 'square-fill',
  [PARSED_FIELD_TYPES.ELLIPSE]: 'circle-fill'
}

export default {
  name: "ShapeLayer",
  components: {
    EditableTextElement,
  },
  mixins: [layerMixin],
  props: {
    node: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'flow',
      'isSavingNodesChanges'
    ]),
    src() {
      if (!this.node.data.publicPath) {
        return null;
      }
      
      return location.origin + '/share?file=' + (this.node.data.publicPath) + '&lightweight&scale=128'
    },
    fallbackIcon() {
      return {
        icon: FALLBACK_ICONS[this.node.type] ?? '',
        color: this.node.data.fill?.type === 'solid'
        ? this.node.data.fill.value || '#000000'
        : '#000000'
      };
    }
  },
}
</script>
